module.exports = __webpack_public_path__ + "img/styles1.475dc3fb.png";